import { render } from "./FieldDecimal.vue?vue&type=template&id=6b7e4536"
import script from "./FieldDecimal.vue?vue&type=script&lang=js"
export * from "./FieldDecimal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__